// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/5/23
// +-------------------------------------------------------------
// |Time: 12:00
// +-------------------------------------------------------------
import useClipboard from "vue-clipboard3";
import {showToast} from "vant";
export const getAuthorizeLink = (params) => {
    let redirect_uri = params?.redirect_uri || window.location.protocol + "//" + window.location.host;
    let app_id = params?.app_id || process.env.VUE_APP_HOME_CLIENT_ID;
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
}
export function setHost(url) {
    return url ? ((url.indexOf('http://') != -1 || url.indexOf('https://') != -1) ? url : `${window.location.protocol}//${url}`) : ''
}
//复制操作
export async function asyncCopy(msg){
    const {toClipboard} = useClipboard();
    try {
        await toClipboard(msg);
        showToast('复制成功');
    } catch (e) {
        showToast(msg);
    }
}
// 动态加载外部链接
export function loadOutsideJS(url) {
    return new Promise((resolve) => {
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        // IE
        if (script.readyState) {
            script.onreadystatechange = () => {
                if (script.readyState == 'loaded'
                    || script.readyState == 'complete') {
                    script.onreadystatechange = null;
                    resolve();
                }
            };
        } else {
            // 其他浏览器
            script.onload = function () {
                resolve();
            };
        }
        document.getElementsByTagName('head')[0].appendChild(script);
    })
}

/**
 * 判断是否为微信浏览器
 * @returns {boolean}
 */
export function is_wechat() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.match(/MicroMessenger/i) == "micromessenger";
}

/**
 * 判断是否为手机
 * @returns {boolean}
 */
export function is_mobile() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const agents = ["android", "iphone", "symbianos", "windows phone", "ipad", "ipod"];
    for (let v = 0; v < agents.length; v++) {
        if (userAgent.indexOf(agents[v]) >= 0) {
            return true;
        }
    }
    return false;
}

/**
 * 判断是否横屏
 * @returns {boolean}
 */
export function isLandscape() {
    // 判断横竖屏
    let width = document.documentElement.clientWidth;
    let height = document.documentElement.clientHeight;
    if (width > height) {
        return true;
    }
    return false
}

/**
 * 判断是否为Safari浏览器
 * @returns {boolean}
 */
export function isSafari() {
    let ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
        ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
        ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1;
}

export const handleToService = () => {
    return window.location.href = process.env.VUE_APP_WECHAT_SERVICE
}